import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ArrowTopRight = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M17.5 6.5L6.5 17.5M8.74512 5.75H16.25C17.3546 5.75 18.25 6.64543 18.25 7.75V16.2458'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.99512 5.75C7.99512 5.33579 8.3309 5 8.74512 5H16.25C17.7688 5 19 6.23122 19 7.75V16.2458C19 16.66 18.6642 16.9958 18.25 16.9958C17.8358 16.9958 17.5 16.66 17.5 16.2458V7.75C17.5 7.68994 17.4958 7.63087 17.4876 7.57307L7.03033 18.0303C6.73744 18.3232 6.26256 18.3232 5.96967 18.0303C5.67678 17.7374 5.67678 17.2626 5.96967 16.9697L16.4269 6.51242C16.3691 6.50423 16.3101 6.5 16.25 6.5H8.74512C8.3309 6.5 7.99512 6.16421 7.99512 5.75Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
